var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinesMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 24H2.25002C1.00928 24 0 22.9907 0 21.75V7.37107C0 6.77049 0.23436 6.20503 0.659194 5.78024L5.78029 0.659194C6.20508 0.23436 6.77049 0 7.37112 0H15.75C16.9907 0 18 1.00928 18 2.25002V21.75C18 22.9907 16.9907 24 15.75 24ZM7.37112 1.49999C7.17408 1.49999 6.98075 1.57985 6.84082 1.71972L1.71972 6.84083C1.57985 6.9807 1.49999 7.17408 1.49999 7.37112V21.75C1.49999 22.1638 1.83615 22.5001 2.25002 22.5001H15.75C16.1638 22.5001 16.5 22.1639 16.5 21.75V2.25002C16.5 1.8362 16.1639 1.49999 15.75 1.49999H7.37112Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinesMenuIcon);
export default __webpack_public_path__ + "static/media/lines_menu_icon.6683f42ff08d38432606ca45f84bcc2d.svg";
export { ForwardRef as ReactComponent };